import React from "react";
import gravatar from "../../../assets/images/gravatar.png";
//import RakutenBanner from '../../../assets/images/rakuten.jpg'

export default function rakuten() {
  return (
    <div className="post-1480 post type-post status-publish format-standard has-post-thumbnail hentry category-news">
      <div className="blog-single-post nosidebar">
        <section className="subpage-banner rakuten-banner"></section>

        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="row">
                <div className="col-sm-2">
                  <img
                    src={gravatar}
                    className="author-avatar img-circle img-responsive"
                    alt="Avatar"
                  />
                </div>

                <div className="col-sm-10">
                  <h2 className="post-title">
                    Singapore’s rewards app ShopBack raises $45m led by EV
                    Growth, Rakuten
                  </h2>
                  <div className="row meta-info">
                    <div className="col-sm-6 col-md-3 info">
                      <span>
                        <i className="fa fa-clock"></i>12 January 2017
                      </span>
                    </div>
                    <div className="col-sm-6 col-md-3 info">
                      <span>
                        <i className="fa fa-comments"></i>No Comments
                      </span>
                    </div>
                    <div className="col-sm-6 col-md-3 info">
                      <span>
                        <i className="fa fa-eye"></i>212 Views
                      </span>
                    </div>
                    <div className="col-sm-6 col-md-3 info">
                      <span>
                        <i className="fa fa-tag"></i>
                        <a href="/news/" rel="category tag">
                          News
                        </a>
                      </span>
                    </div>
                  </div>

                  <div className="post-article">
                    <p>
                      (April 2019:
                      https://www.dealstreetasia.com/stories/singapore-startup-shopback-snags-45m-in-rakuten-led-round-129974/)
                    </p>
                    <p>
                      ShopBack, a Singapore-based rewards discovery platform,
                      has raised $45 million in a Series B funding led by EV
                      Growth and Rakuten Capital.{" "}
                    </p>
                    <p>
                      EDBI and other existing investors also participated in
                      this round. A number of appointments have also been made
                      to ShopBack’s board as a result of the capital raise. Amit
                      Patel, CEO of Ebates, Inc., a Rakuten company, and Willson
                      Cuaca, managing partner of EV Growth, will join ShopBack’s
                      board of directors.{" "}
                    </p>
                    <p>
                      ShopBack’s current list of investors includes SoftBank
                      Ventures Asia, Credit Saison, Qualgro, Accel-X, East
                      Ventures, Blue Sky Alternative Investments, NUS Technology
                      Holdings, AppWorks Ventures, Intouch Holdings PCL, Aetius
                      Global Limited, Cornerstone Ventures and 33 Capital Group.
                    </p>
                    <p>
                      According to a statement, ShopBack will deploy the new
                      funds into simplifying shopping experiences, expanding
                      data capabilities, and accelerating market growth. It will
                      also continue to build rewards and discovery features for
                      its Asia Pacific consumers on and offline.
                    </p>
                    <p>
                      Henry Chan, CEO and co-founder of ShopBack said: “Our
                      rapidly growing pool of loyal users is a strong testament
                      to the value we bring to merchant partners and consumers
                      across Asia Pacific.” ShopBack said that it has seen its
                      orders and sales expand 250 per cent year-on-year in 2018.
                      It reports over 2.5 million monthly transactions to
                      deliver over $1 billion of sales for its seven million
                      users across the Asia Pacific.
                    </p>
                    <p>
                      Last year ShopBack entered Australia, its first market
                      outside of Asia. It has also since opened research and
                      development hubs in Vietnam and Taiwan. Willson Cuaca,
                      Managing Partner at EV Growth said: “We are constantly
                      energised by ShopBack’s rapid growth since its early days.
                      As a follow-on investor from East Ventures to EV Growth,
                      the founders have stayed true to the company’s mission of
                      helping end users make smarter purchase decisions.”
                    </p>
                    <p>
                      ShopBack is present in seven Asia Pacific markets:
                      Singapore, the Philippines, Malaysia, Indonesia, Taiwan,
                      Thailand, Australia. It also holds partnerships with
                      global names like Visa and Mastercard, as well as over
                      2,000 merchant partners across on and offline spaces.
                    </p>

                    <div className="media-image"></div>
                  </div>

                  <hr></hr>

                  <div className="social-share">
                    <div className="row">
                      <div className="col-xs-6 share-text">Share</div>
                      <div className="col-xs-6 share-button">
                        <div className="btn-group">
                          <a
                            href="https://www.facebook.com/sharer/sharer.php?u=https://33-capital.com/this-swedish-crowdfunding-hit-is-taking-on-daniel-wellington-by-letting-you-design-a-personalized-luxury-watch/"
                            className="btn btn-default"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="icon-facebook"></i>
                          </a>
                          <a
                            href="https://plus.google.com/share?url=https://33-capital.com/this-swedish-crowdfunding-hit-is-taking-on-daniel-wellington-by-letting-you-design-a-personalized-luxury-watch/"
                            className="btn btn-default"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="icon-gplus"></i>
                          </a>
                          <a
                            href="https://twitter.com/intent/tweet?text=This Swedish crowdfunding hit is taking on Daniel Wellington – by letting you design a personalized luxury watch&amp;url=https://33-capital.com/this-swedish-crowdfunding-hit-is-taking-on-daniel-wellington-by-letting-you-design-a-personalized-luxury-watch/"
                            className="btn btn-default"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="icon-twitter"></i>
                          </a>
                          <a
                            href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https://33-capital.com/this-swedish-crowdfunding-hit-is-taking-on-daniel-wellington-by-letting-you-design-a-personalized-luxury-watch/&amp;title=This Swedish crowdfunding hit is taking on Daniel Wellington – by letting you design a personalized luxury watch&amp;summary=(Jan 2017: http://nordic.businessinsider.com/this-swedish-crowdfunding-hit-is-taking-on-daniel-wellington—by-letting-you-design-your-own-scandinavian-made-luxury-watch-2017-1/) Daniel Wellington, the Swedish watch empire headed by Filip Tysander, defined the watch trends for millenials in the post 2010-era. A social media-savvy marketing strategy, combined with an accurate reading of prevailing trends and a seamless supply chain made the company’s revenues explode from 0 to $100+ million within five years. But now&amp;source=https://33-capital.com/this-swedish-crowdfunding-hit-is-taking-on-daniel-wellington-by-letting-you-design-a-personalized-luxury-watch/"
                            className="btn btn-default"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="icon-linkedin"></i>
                          </a>
                          <a
                            href="https://pinterest.com/pin/create/button/?url=https://33-capital.com/this-swedish-crowdfunding-hit-is-taking-on-daniel-wellington-by-letting-you-design-a-personalized-luxury-watch/&amp;description=(Jan 2017: http://nordic.businessinsider.com/this-swedish-crowdfunding-hit-is-taking-on-daniel-wellington—by-letting-you-design-your-own-scandinavian-made-luxury-watch-2017-1/) Daniel Wellington, the Swedish watch empire headed by Filip Tysander, defined the watch trends for millenials in the post 2010-era. A social media-savvy marketing strategy, combined with an accurate reading of prevailing trends and a seamless supply chain made the company’s revenues explode from 0 to $100+ million within five years. But now&amp;media="
                            className="btn btn-default"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="icon-pinterest"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr></hr>
                  <div className="comment-count">No Comments </div>
                  <hr></hr>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/News/posts/rakuten.js